(() => {
  if (window.WubCollectionMobileViewportV24) return;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  let ticking = false;

  function updateStickyFilterBars() {
    ticking = false;
    if (!mobileQuery.matches) return;

    document.querySelectorAll('[data-wub-collection] [data-wub-collection-actions]').forEach((bar) => {
      const root = bar.closest('[data-wub-collection]');
      const toolbar = root?.querySelector('.wub-collection-v2__toolbar');
      if (!root || !toolbar) return;

      const toolbarRect = toolbar.getBoundingClientRect();
      const toolbarHasPassed = toolbarRect.bottom <= 0;
      const revealOnScroll = bar.dataset.revealOnScroll === 'true';
      const revealOffset = parseInt(bar.dataset.revealOffset || '0', 10);
      const offsetPassed = !revealOnScroll || window.scrollY >= revealOffset;

      bar.classList.toggle('is-visible', toolbarHasPassed && offsetPassed);
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateStickyFilterBars);
  }

  function closeSiblingQuickFilters(details) {
    const row = details.closest('[data-wub-mobile-promoted-filters]');
    if (!row) return;
    row.querySelectorAll('[data-wub-mobile-promoted-filter][open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
  }

  function handleDocumentClick(event) {
    if (!mobileQuery.matches) return;

    const summary = event.target.closest('[data-wub-mobile-promoted-filter] > summary');
    if (summary) {
      const details = summary.parentElement;
      requestAnimationFrame(() => {
        if (details?.open) closeSiblingQuickFilters(details);
      });
      return;
    }

    if (!event.target.closest('[data-wub-mobile-promoted-filters]')) {
      document.querySelectorAll('[data-wub-mobile-promoted-filter][open]').forEach((details) => {
        details.open = false;
      });
    }
  }

  function handleDocumentKeydown(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-wub-mobile-promoted-filter][open]').forEach((details) => {
      details.open = false;
    });
  }

  function boot() {
    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentKeydown);
    document.addEventListener('wub:collection-updated', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    setTimeout(boot, 0);
  }

  window.WubCollectionMobileViewportV24 = { refresh: requestUpdate };
})();
